export default "__VITE_ASSET__CV$HZX73__"